import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  .themes-container {
    display: flex;
    gap: var(--sds-size-space-300);
    margin: var(--sds-size-space-600) 0;
    align-items: flex-start;
    align-content: flex-start;
    align-self: stretch;
    flex-wrap: wrap;
  }

  .theme-pill {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-300);
    padding: var(--sds-size-space-400) var(--sds-size-space-600);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-secondary);
    border-color: var(--sds-color-border-default-secondary);
    border-radius: 100px;
    background: var(--sds-color-background-default-default);
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
    color: var(--sds-color-text-default-secondary);

    /* Body Base */
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%; /* 19.6px */
  }

  .theme-pill:hover {
    border-color: var(--sds-color-border-neutral-default);
    background: var(--sds-color-background-default-secondary);

    color: var(--sds-color-text-default-default);
    text-shadow: 0 4px 4px rgb(0 0 0 / 0.25);

    /* Body Base */
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%; /* 19.6px */
  }

  .theme-pill.selected {
    border-color: var(--sds-color-border-neutral-default);
    background: var(--sds-color-background-default-secondary);

    color: var(--sds-color-text-default-default);
    text-shadow: 0 4px 4px rgb(0 0 0 / 0.25);

    /* Body Base */
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%; /* 19.6px */
  }

  .checkmark {
    width: var(--sds-size-icon-small);
    height: var(--sds-size-icon-small);
    color: var(--sds-color-text-brand-default);
  }

  .theme-text {
    white-space: nowrap;
  }

  /* @media (max-width: 768px) {
    .themes-container {
      gap: var(--sds-size-space-300);
    }

    .theme-pill {
      padding: var(--sds-size-space-400) var(--sds-size-space-600);
      font-size: var(--sds-typography-scale-01);
    } */
  /* } */
`;
